import { OnboardingUser } from '../models/onboardingUser';
import { IOnboardingUserData } from '../interfaces/models';

export class OnboardingUserFactory {
    protected userData: IOnboardingUserData;
    protected finalUserAttributesToSend: IOnboardingUserData;

    constructor(userData: IOnboardingUserData) {
        this.userData = userData;
    }

    public build(): IOnboardingUserData {
        this.preparePersonalData()
            .prepareFinancialPercentData()
            .removeUndefinedAttributes();

        return this.finalUserAttributesToSend;
    }

    private preparePersonalData() {
        this.userData.firstName = this.formatFullNameToFirstName(this.userData.firstName);
        this.userData.isInMobileApp = window['isToroMobile'] ? true : false;
        const urlString = window.location.href;
        const url = new URL(urlString);

        this.userData.showFlow = url.searchParams.get('showFlow') || 'none';
        this.userData.showChecklist = url.searchParams.get('showChecklist') || 'none';
        return this;
    }

    private formatFullNameToFirstName(name: string): string {
        if (name) {
            const nameHasSpace = name.indexOf(' ') > -1;

            if (nameHasSpace) {
                name = name.split(' ')[0];
            }
        }

        return name;
    }

    private prepareFinancialPercentData() {
        if (this.userData.patrimonyBalance) {
            const percentUnit = this.userData.patrimonyBalance / 100;

            if (this.userData.totalExchange) {
                this.userData.percentTotalExchange = this.userData.totalExchange / percentUnit;
            } else {
                this.userData.percentTotalExchange = 0;
            }

            if (this.userData.totalFixedIncome) {
                this.userData.percentTotalFixedIncome = this.userData.totalFixedIncome / percentUnit;
            } else {
                this.userData.percentTotalFixedIncome = 0;
            }

            if (this.userData.totalFunds) {
                this.userData.percentTotalFunds = this.userData.totalFunds / percentUnit;
            } else {
                this.userData.percentTotalFunds = 0;
            }
        }

        return this;
    }

    private removeUndefinedAttributes() {
        this.finalUserAttributesToSend = new OnboardingUser({});
        const userAttributes = Object.keys(this.userData);

        userAttributes.forEach((attribute) => {
            if (typeof this.userData[attribute] !== 'undefined') {
                this.finalUserAttributesToSend[attribute] = this.userData[attribute];
            }
        });

        return this;
    }
}
